import React from 'react';
import { createRoot } from 'react-dom/client';
import { QRCodeSVG } from 'qrcode.react';
import { loadGoogleMapsScript, mapCssScale } from '../util/googleMaps';
import { resolveMapCenter } from '../util/mapCenter';
import { fetchGoogleNearbyPlaces, fetchGooglePlaceDetails } from '../util/places';
import { googleMapsApiKeyENV, googleMapIdENV } from '../ENV';
import '../styles/amenitiesGlobal.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faUtensils, faCoffee, faBed, faUniversity, faGasPump, faStore, faCreditCard, faShoppingBasket,
	faPills, faShoppingBag, faDumbbell, faHeartbeat, faSpa, faSeedling, faGift, faHospital,
	faEnvelope, faSubway, faCar, faPlaceOfWorship, faBookOpen, faTree, faLandmark, faFilm,
	faBeer, faMusic, faWineGlass, faBreadSlice, faBook, faWind, faTshirt, faTag, faTv, faTools,
	faPlus, faMinus, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faAngleDoubleDown, faAngleDoubleRight, faTimes
} from '@fortawesome/free-solid-svg-icons';

const CATEGORIES = [
	{ id: '13065', label: 'Restaurant',        icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_restaurant.png', fa: faUtensils },
	{ id: '13032', label: 'Café',              icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_cafe.png', fa: faCoffee },
	{ id: '19009', label: 'Lodging',           icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_lodging.png', fa: faBed },
	{ id: '11045', label: 'Bank',              icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_bank.png', fa: faUniversity },
	{ id: '19007', label: 'Gas Station',       icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_gas_station.png', fa: faGasPump },
	{ id: '17029', label: 'Convenience',       icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_convenience_store.png', fa: faStore },
	{ id: '11044', label: 'ATM',               icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_atm.png', fa: faCreditCard },
	{ id: '17069', label: 'Grocery',           icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_grocery_or_supermarket.png', fa: faShoppingBasket },
	{ id: '17035', label: 'Pharmacy',          icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_pharmacy.png', fa: faPills },
	{ id: '17114', label: 'Shopping Mall',     icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_shopping_mall.png', fa: faShoppingBag },
	{ id: '18021', label: 'Gym',               icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_gym.png', fa: faDumbbell },
	{ id: '11061', label: 'Health & Beauty',   icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_beauty_salon.png', fa: faHeartbeat },
	{ id: '11073', label: 'Spa',               icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_spa.png', fa: faSpa },
	{ id: '17056', label: 'Florist',           icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_florist.png', fa: faSeedling },
	{ id: '17089', label: 'Gifts',             icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_gift_store.png', fa: faGift },
	{ id: '15014', label: 'Hospital',          icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_hospital.png', fa: faHospital },
	{ id: '12075', label: 'Post Office',       icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_post_office.png', fa: faEnvelope },
	{ id: '19047', label: 'Rail Station',      icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_train_station.png', fa: faSubway },
	{ id: '11011', label: 'Car Wash',          icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_car_wash.png', fa: faCar },
	{ id: '12098', label: 'Spiritual Center',  icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_place_of_worship.png', fa: faPlaceOfWorship },
	{ id: '12080', label: 'Library',           icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_library.png', fa: faBookOpen },
	{ id: '16032', label: 'Park',              icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_park.png', fa: faTree },
	{ id: '10027', label: 'Museum',            icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_museum.png', fa: faLandmark },
	{ id: '10024', label: 'Movie Theater',     icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_movie_theater.png', fa: faFilm },
	{ id: '13003', label: 'Bar',               icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_bar.png', fa: faBeer },
	{ id: '10032', label: 'Night Club',        icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_night_club.png', fa: faMusic },
	{ id: '17076', label: 'Liquor Store',      icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_liquor_store.png', fa: faWineGlass },
	{ id: '13002', label: 'Bakery',            icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_bakery.png', fa: faBreadSlice },
	{ id: '17018', label: 'Bookstore',         icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_book_store.png', fa: faBook },
	{ id: '11066', label: 'Dry Cleaner',       icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_dry_cleaner.png', fa: faWind },
	{ id: '11069', label: 'Laundry',           icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_laundry.png', fa: faTshirt },
	{ id: '17043', label: 'Clothing Store',    icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_clothing_store.png', fa: faTag },
	{ id: '17023', label: 'Electronics',       icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_electronics_store.png', fa: faTv },
	{ id: '17090', label: 'Hardware Store',    icon: 'https://ts-condor-assets.s3.amazonaws.com/images/legacy-icons/ic_hardware_store.png', fa: faTools },
];

const INFO_WINDOW_FALLBACK_HEIGHT_PX = 300;

const CATEGORY_FETCH_DEBOUNCE_MS = 250;

function buildPhotoUrl(photoName, maxWidth) {
	const width = maxWidth || 400;
	if (!photoName || !googleMapsApiKeyENV) {
		return null;
	}
	return `https://maps.googleapis.com/maps/api/place/photo?maxwidth=${width}&photoreference=${encodeURIComponent(photoName)}&key=${encodeURIComponent(googleMapsApiKeyENV)}`;
}

function renderPriceLevel(level) {
	if (!level || level < 1) return null;
	return <span className="amenGoogleListPrice">{'$'.repeat(level)}</span>;
}

function formatPlaceType(type) {
	if (!type) return null;
	const skip = new Set(['point_of_interest', 'establishment', 'food', 'store', 'health', 'finance']);
	if (skip.has(type)) return null;
	return type.replace(/_/g, ' ');
}

const TYPE_PRIORITY = ['restaurant', 'cafe', 'bar', 'bakery', 'night_club', 'lodging',
	'gym', 'spa', 'beauty_salon', 'hospital', 'pharmacy', 'bank', 'atm',
	'supermarket', 'convenience_store', 'gas_station', 'shopping_mall',
	'museum', 'park', 'library', 'movie_theater', 'post_office', 'florist',
	'car_wash', 'laundry', 'clothing_store', 'electronics_store', 'hardware_store',
	'book_store', 'liquor_store', 'train_station', 'place_of_worship'];

function getDisplayType(types) {
	if (!Array.isArray(types)) return null;
	for (const preferred of TYPE_PRIORITY) {
		if (types.includes(preferred)) {
			const label = formatPlaceType(preferred);
			if (label) return label;
		}
	}
	for (const t of types) {
		const label = formatPlaceType(t);
		if (label) return label;
	}
	return null;
}

function getOpenStatus(place) {
	if (place.business_status && place.business_status !== 'OPERATIONAL') {
		const label = place.business_status.replace(/_/g, ' ').toLowerCase();
		return { label, open: false };
	}
	if (place.open_now !== null && place.open_now !== undefined) {
		return { label: place.open_now ? 'Open now' : 'Closed', open: place.open_now };
	}
	return null;
}

function formatTime24(hhmm) {
	const h = parseInt(hhmm.slice(0, 2), 10);
	const m = hhmm.slice(2);
	const ampm = h >= 12 ? 'PM' : 'AM';
	const h12 = h % 12 || 12;
	return `${h12}:${m} ${ampm}`;
}

function getHoursText(openNow, periods, weekdayText) {
	if (weekdayText && weekdayText.length === 7) {
		const todayText = weekdayText[(new Date().getDay() + 6) % 7];
		if (todayText) {
			if (/closed/i.test(todayText)) {
				// Fall through to periods-based parsing below.
			} else if (/24 hours/i.test(todayText)) {
				return 'Open 24 hours';
			} else {
				const normalised = todayText.replace(/[\u00a0\u202f\u2009\u2007\u200a\t]+/g, ' ');
				const colonIdx = normalised.indexOf(':');
				const timesPart = colonIdx >= 0 ? normalised.slice(colonIdx + 1).trim() : normalised.trim();
				const ranges = timesPart.split(',').map((s) => s.trim());
				if (openNow !== false) {
					const now = new Date();
					const curr = now.getHours() * 60 + now.getMinutes();
					for (const range of ranges) {
						const parts = range.split(/[\u2013\u2014\u002d]/);
						if (parts.length < 2) continue;
						const closeStr = parts[parts.length - 1].trim();
						const openStr  = parts[0].trim();
						const toMin = (s) => {
							const m = s.match(/(\d+):(\d+)\s*([AP]M)/i);
							if (!m) return -1;
							let h = parseInt(m[1], 10);
							const min = parseInt(m[2], 10);
							const ap = m[3].toUpperCase();
							if (ap === 'PM' && h !== 12) h += 12;
							if (ap === 'AM' && h === 12) h = 0;
							return h * 60 + min;
						};
						const openMin  = toMin(openStr);
						const closeMin = toMin(closeStr);
						if (openMin < 0 || closeMin < 0) continue;
						const spansM = closeMin < openMin;
						const inRange = spansM
							? (curr >= openMin || curr < closeMin)
							: (curr >= openMin && curr < closeMin);
						if (inRange) return `Open until ${closeStr}`;
					}
					const lastRange = ranges[ranges.length - 1];
					const lastParts = lastRange.split(/[\u2013\u2014\u002d]/);
					if (lastParts.length >= 2) return `Open until ${lastParts[lastParts.length - 1].trim()}`;
					return 'Open now';
				} else {
					// Fall through to periods-based parsing below.
				}
			}
		}
	}

	if (!periods || periods.length === 0) {
		if (openNow === true)  return 'Open now';
		if (openNow === false) return 'Closed';
		return null;
	}

	const now  = new Date();
	const day  = now.getDay();
	const curr = now.getHours() * 100 + now.getMinutes();
	const prevDay = (day + 6) % 7;

	if (openNow !== false) {
		let active = periods.find((p) => {
			if (p.open.day !== day) return false;
			if (!p.close) return true;
			const closeDay  = p.close.day;
			const closeTime = parseInt(p.close.time, 10);
			const openTime  = parseInt(p.open.time, 10);
			if (closeDay === day) return curr >= openTime && curr < closeTime;
			return curr >= openTime;
		});
		if (!active) {
			active = periods.find((p) => {
				if (p.open.day !== prevDay || !p.close || p.close.day !== day) return false;
				return curr < parseInt(p.close.time, 10);
			});
		}
		if (active && active.close) return `Open until ${formatTime24(active.close.time)}`;
		return 'Open now';
	}

	for (let d = 0; d < 7; d++) {
		const checkDay = (day + d) % 7;
		const candidates = periods
			.filter((p) => p.open.day === checkDay)
			.map((p) => parseInt(p.open.time, 10))
			.sort((a, b) => a - b);
		for (const openTime of candidates) {
			if (d > 0 || openTime > curr) {
				const hhmm = String(openTime).padStart(4, '0');
				const label = d === 1 ? ' tomorrow' : '';
				return `Opens at ${formatTime24(hhmm)}${label}`;
			}
		}
	}
	return 'Closed';
}

/**
 * Hero image for the detail popup, or the place's category mark when the owner
 * uploaded no photo. Fallback order must match PlaceThumb / renderCategoryRail so
 * the popup shows the same mark as the row that opened it.
 */
export function InfoWindowPhoto({ place, catMeta }) {
	const [imgError, setImgError] = React.useState(false);
	const photoUrl = buildPhotoUrl(place.photo_name, 400);

	if (photoUrl && !imgError) {
		return (
			<img
				src={photoUrl}
				alt={place.name}
				style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
				onError={(e) => {
					setImgError(true);
					e.target.onerror = null;
				}}
			/>
		);
	}

	const fallbackStyle = {
		width: '100%', height: '100%',
		display: 'flex', alignItems: 'center', justifyContent: 'center',
		background: 'var(--amenities-rail-bg-color, #EFF4F7)',
		color: 'var(--amenities-icon-color, #5E5E5E)',
	};

	if (catMeta && catMeta.fa) {
		return (
			<div style={fallbackStyle}>
				<FontAwesomeIcon icon={catMeta.fa} aria-hidden="true" style={{ fontSize: '2.6em', opacity: 0.9 }} />
			</div>
		);
	}
	if (catMeta && catMeta.icon) {
		return (
			<div style={fallbackStyle}>
				<img src={catMeta.icon} alt="" aria-hidden="true" style={{ width: '2.6em', height: '2.6em', opacity: 0.9 }} />
			</div>
		);
	}
	return <div style={fallbackStyle} />;
}

export function MapInfoWindowContent({ place, mapsLink, onClose, hoursText, fullAddress, phone, catMeta }) {
	const displayType = getDisplayType(place.types);
	const openStatus  = getOpenStatus(place);
	const priceStr    = (place.price_level > 0) ? '$'.repeat(place.price_level) : null;
	const fullStars   = Math.floor(place.rating || 0);
	const halfStar    = (place.rating - fullStars) >= 0.5;
	const emptyStars  = 5 - fullStars - (halfStar ? 1 : 0);

	const addressText = fullAddress || place.formatted_address;

	const ratingLine = place.rating > 0
		? <>
			<span style={{ color: '#f5a800' }}>{'★'.repeat(fullStars)}{halfStar ? '½' : ''}{'☆'.repeat(emptyStars)}</span>
			{' '}<span style={{ fontWeight: 'normal' }}>{place.rating.toFixed(1)}</span>
			{place.user_ratings_total > 0 && (
				<span style={{ color: '#777' }}> ({place.user_ratings_total.toLocaleString()} reviews)</span>
			)}
		</>
		: null;

	const simpleStatus = openStatus ? openStatus.label : null;
	const simpleStatusColor = openStatus && openStatus.open ? '#2e7d32' : '#c62828';

	const metaParts = [
		displayType  ? <span key="t" style={{ textTransform: 'capitalize' }}>{displayType}</span>  : null,
		priceStr     ? <span key="p" style={{ color: '#2e7d32', fontWeight: 600 }}>{priceStr}</span> : null,
		simpleStatus ? <span key="o" style={{ color: simpleStatusColor, fontWeight: 600 }}>{simpleStatus}</span> : null,
	].filter(Boolean);

	return (
		<div style={{ width: '290px', minWidth: '290px', fontFamily: 'sans-serif', fontSize: '13px', color: '#222', overflow: 'hidden' }}>

			{/* ── image with X overlay ── */}
			<div style={{ position: 'relative', width: '100%', height: '130px', background: '#ddd', flexShrink: 0 }}>
				<InfoWindowPhoto place={place} catMeta={catMeta} />
				<button
					onClick={onClose}
					type="button"
					style={{
						position: 'absolute', top: '7px', right: '7px',
						width: '24px', height: '24px',
						boxSizing: 'border-box', padding: 0, margin: 0,
						WebkitAppearance: 'none', appearance: 'none',
						background: 'rgba(0,0,0,0.55)', border: 'none', borderRadius: '50%',
						color: '#fff', fontSize: '13px', lineHeight: 1,
						display: 'flex', alignItems: 'center', justifyContent: 'center',
						cursor: 'pointer', zIndex: 2, touchAction: 'manipulation',
					}}
					aria-label="Close"
				>
					<FontAwesomeIcon
						icon={faTimes}
						aria-hidden="true"
						style={{ display: 'block', fontSize: '14px', pointerEvents: 'none' }}
					/>
				</button>
			</div>

			{/* ── middle: 3 lines + QR ── */}
			<div style={{ display: 'flex', padding: '9px 10px 6px', gap: '8px', alignItems: 'center' }}>
				{/* left: three lines */}
				<div style={{ flex: 1, minWidth: 0 }}>
					<div style={{ fontWeight: 700, fontSize: '15px', lineHeight: 1.2, marginBottom: '3px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
						{place.name}
					</div>
					{ratingLine && (
						<div style={{ fontSize: '12px', lineHeight: 1.3, marginBottom: '2px' }}>
							{ratingLine}
						</div>
					)}
					{metaParts.length > 0 && (
						<div style={{ fontSize: '11px', display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center', lineHeight: 1.3 }}>
							{metaParts.reduce((acc, el, i) => (i === 0 ? [el] : [...acc, <span key={`sep${i}`} style={{ color: '#bbb' }}>·</span>, el]), [])}
						</div>
					)}
					{phone && (
						<div style={{ fontSize: '11px', color: '#444', display: 'flex', gap: '4px', alignItems: 'center', marginTop: '3px', lineHeight: 1.3 }}>
							<svg viewBox="0 0 24 24" fill="#555" width="11" height="11" aria-hidden="true" style={{ flexShrink: 0 }}>
								<path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24 11.47 11.47 0 0 0 3.58.57 1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11.47 11.47 0 0 0 .57 3.58 1 1 0 0 1-.25 1.01z"/>
							</svg>
							<span>{phone}</span>
						</div>
					)}
				</div>
				{/* right: QR */}
				<div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px' }}>
					<div style={{ fontSize: '9px', color: '#888', whiteSpace: 'nowrap' }}>Directions</div>
					<QRCodeSVG value={mapsLink} size={72} bgColor="white" fgColor="#222" level="M" />
				</div>
			</div>

			{/* ── divider ── */}
			<div style={{ height: '1px', background: '#eee', margin: '0 10px' }} />

			{/* ── address ── */}
			{addressText && (
				<div style={{ padding: '6px 10px 3px', fontSize: '12px', color: '#444', display: 'flex', gap: '6px', alignItems: 'flex-start', lineHeight: 1.4 }}>
					<span style={{ flexShrink: 0, marginTop: '1px' }}>
						<svg viewBox="0 0 24 24" fill="#ea4335" width="14" height="14" aria-hidden="true">
							<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
						</svg>
					</span>
					<span>{addressText}</span>
				</div>
			)}

			{/* ── hours: detailed text only ── */}
			{hoursText && (
				<div style={{ padding: '0 10px 9px', fontSize: '12px', display: 'flex', gap: '6px', alignItems: 'center',
					color: hoursText.startsWith('Open') ? '#2e7d32' : '#c62828' }}>
					<span style={{ flexShrink: 0 }}>
						<svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" aria-hidden="true">
							<path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>
						</svg>
					</span>
					<span style={{ fontWeight: 600 }}>{hoursText}</span>
				</div>
			)}
		</div>
	);
}

function renderStars(rating) {
	const full  = Math.floor(rating);
	const half  = rating - full >= 0.5 ? 1 : 0;
	const empty = 5 - full - half;
	return (
		<span className="amenGoogleStars" aria-label={`Rating: ${rating} out of 5`}>
			{'★'.repeat(full)}
			{half ? '½' : ''}
			{'☆'.repeat(empty)}
		</span>
	);
}

/**
 * Creates a DOM element used as the content for a category map pin.
 * Extracted as a module-level function because it has no dependency on
 * component instance state or methods — only the CATEGORIES constant.
 */
function createCategoryPinElement(categoryId) {
	const category = CATEGORIES.find((c) => c.id === categoryId);
	const pinEl = document.createElement('div');
	pinEl.className = 'amenGoogleMapPin';

	const iconWrapper = document.createElement('div');
	iconWrapper.className = 'amenGoogleMapPinIcon';

	if (category && category.fa) {
		const root = createRoot(iconWrapper);
		root.render(<FontAwesomeIcon icon={category.fa} aria-hidden="true" />);
	} else if (category && category.label) {
		iconWrapper.textContent = category.label.charAt(0);
	}

	pinEl.appendChild(iconWrapper);
	return pinEl;
}

/**
 * Thumbnail (or icon fallback) for a listing-panel row. Fallback order must match
 * renderCategoryRail(): a place with no photo shows its category's own mark.
 */
export function PlaceThumb({ place, catMeta }) {
	const [imgError, setImgError] = React.useState(false);
	const photoUrl = buildPhotoUrl(place.photo_name, 200);
	if (photoUrl && !imgError) {
		return (
			<img
				className="amenGoogleThumbImg"
				src={photoUrl}
				alt={place.name}
				onError={(e) => {
					setImgError(true);
					e.target.onerror = null;
				}}
			/>
		);
	}
	if (catMeta && catMeta.fa) {
		return <FontAwesomeIcon icon={catMeta.fa} className="amenGoogleThumbIcon" aria-hidden="true" />;
	}
	const iconSrc = (catMeta && catMeta.icon) || '';
	if (iconSrc) {
		return <img className="amenGoogleThumbIcon" src={iconSrc} alt="" aria-hidden="true" />;
	}
	return null;
}

class AmenitiesResponsiveMap extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			css:           props.CSSModules[props.condor_render_name],
			mapsReady:     false,
			category:      '',
			results:       null,
			fetchFailed:   false,
			loading:       false,
			selectedPlace: null,
			panelOpen:     false,
			isPortrait:    false,
		};

		this.mapContainerRef = React.createRef();
		this.listPanelRef    = React.createRef();
		this.railRef         = React.createRef();
		this.listScrollRef   = React.createRef();
		this.googleMap       = null;
		this.markers         = [];
		this.yahMarker       = null;
		this.advancedMarkersEnabled = false;
		this.infoWindow      = null;
		this.infoWindowRoot  = null;
		this.resultCache     = {};
		this.inFlightCategories = new Set();
		this.cacheGeneration = 0;
		this.idleTimer       = null;
		this.categoryFetchTimer = null;
		this.resizeObserver  = null;
		this._railDrag       = null;
		this._listDrag       = null;

		this.containerId = `amenitiesGoogleMap_${props.component_name}`;

		const { lat, lng } = resolveMapCenter(props);
		this.latitude  = lat;
		this.longitude = lng;
	}

	componentDidMount() {
		this._mounted = true;
		this.detectOrientation();
		this.resizeObserver = new ResizeObserver(() => this.detectOrientation());
		if (this.mapContainerRef.current) {
			this.resizeObserver.observe(this.mapContainerRef.current);
		}

			loadGoogleMapsScript(googleMapsApiKeyENV)
			.then(() => {
				if (this._mounted) {
					this.setState({ mapsReady: true }, () => this.createMap());
				}
			})
			.catch((err) => {
				console.error('AmenitiesMap: Google Maps failed to load:', err.message);
			});
		this._applyAdaDefaultScroll();
	}

	componentWillUnmount() {
		this._mounted = false;
		clearTimeout(this.idleTimer);
		clearTimeout(this.categoryFetchTimer);
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
		this.clearMarkers();
		if (this.yahMarker) {
			this.yahMarker.map = null;
			this.yahMarker = null;
		}
		if (this.googleMap && window.google?.maps?.event) {
			window.google.maps.event.clearInstanceListeners(this.googleMap);
		}
		this.infoWindow = null;
		this.googleMap = null;
	}

	/**
	 * Toggling ADA inserts or removes the reach spacer *above* the content of both scroll
	 * regions, which shifts everything below it. Measure how tall the spacer is while the
	 * old DOM is still up, so componentDidUpdate can cancel that shift out exactly.
	 *
	 * This runs after render but before the browser paints, which is the whole point —
	 * doing the same work in requestAnimationFrame leaves one painted frame at the wrong
	 * offset, and that frame is the flicker.
	 */
	getSnapshotBeforeUpdate(prevProps, prevState) {
		if (this.isAdaActive(prevProps) === this.isAdaActive()) { return null; }
		const isPortrait = prevState.isPortrait;
		return {
			isPortrait,
			rail: this._scrollSnapshot(this.railRef.current, isPortrait),
			list: this._scrollSnapshot(this.listScrollRef.current, isPortrait),
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const prevPhase = prevProps.navProps && prevProps.navProps.animationPhase;
		const currPhase = this.props.navProps && this.props.navProps.animationPhase;
		const leavingView  = prevProps.showPhase === true && this.props.showPhase === false;
		const noGroupParent = this.props.showPhase === undefined;
		if (leavingView || (prevPhase !== currPhase && noGroupParent)) {
			this.resetMap();
			return;
		}

		if (snapshot) {
			this._absorbSpacerShift(this.railRef.current, snapshot.rail, snapshot.isPortrait);
			this._absorbSpacerShift(this.listScrollRef.current, snapshot.list, snapshot.isPortrait);
		}
	}

	/**
	 * ADA mode is a runtime nav state, not a setting — it arrives on navProps and flips
	 * when the user presses the ADA button (see Listings.js for the same read).
	 */
	isAdaActive(props = this.props) {
		return !!(props.navProps && props.navProps.adaActive);
	}

	/** How far a region's content is pushed down (or right) by its reach spacer. */
	_spacerExtent(el, isPortrait) {
		if (!el) { return 0; }
		const spacer = el.querySelector('.amenGoogleScrollSpacer');
		if (!spacer) { return 0; }
		return isPortrait ? spacer.offsetWidth : spacer.offsetHeight;
	}

	/** Spacer size *and* scroll offset, both read before the DOM mutates. */
	_scrollSnapshot(el, isPortrait) {
		if (!el) { return null; }
		return {
			extent: this._spacerExtent(el, isPortrait),
			offset: isPortrait ? el.scrollLeft : el.scrollTop,
		};
	}

	/**
	 * Keeps whatever the user was looking at in place across an ADA toggle by moving the
	 * scroll offset by exactly as much as the spacer moved the content.
	 *
	 * Falling out of this for free: a user sitting at the default position lands back on
	 * the default position. Turning ADA on from the top of the list (scrollTop 0) leaves
	 * scrollTop at the spacer height, which *is* the anchored position — so there is no
	 * separate "re-anchor" step to fight with, and nobody gets thrown back to the first
	 * category.
	 *
	 * The target is absolute, computed from the offset captured *before* the mutation. It
	 * must not be `el[axis] + delta`: by the time this runs the browser has already clamped
	 * the offset to the new scroll range, and Chrome's scroll anchoring may already have
	 * compensated for the inserted node — so adding the delta to what is there now applies
	 * the same shift twice. Removing the spacer while scrolled near the bottom of a list is
	 * the easy repro: it jumps a full viewport.
	 */
	_absorbSpacerShift(el, before, isPortrait) {
		if (!el || !before) { return; }
		const delta = this._spacerExtent(el, isPortrait) - before.extent;
		if (!delta) { return; }
		const axis = isPortrait ? 'scrollLeft' : 'scrollTop';
		this._scrollInstantly(el, axis, Math.max(0, before.offset + delta));
	}

	/**
	 * Sets a scroll offset without animating it.
	 *
	 * The scroll containers carry `scroll-behavior: smooth` so the on-screen scroll buttons
	 * glide. That also applies to assignments like `el.scrollTop = x`, which turns every
	 * programmatic re-anchor into a visible scroll — read as the rail "resetting" itself.
	 * The property is suspended for the assignment and restored immediately; the whole
	 * thing is synchronous, so no frame is painted with it off.
	 */
	_scrollInstantly(el, axis, value) {
		const previous = el.style.scrollBehavior;
		el.style.scrollBehavior = 'auto';
		el[axis] = value;
		el.style.scrollBehavior = previous;
	}

	/**
	 * Anchors a spacer-backed scroll region past its spacer, so content reads top-down by
	 * default and the spacer is what a user reveals by scrolling back. With ADA off there
	 * is no spacer and the target is simply 0.
	 */
	_anchorPastSpacer(el, isPortrait) {
		if (!el) { return; }
		const spacer = el.querySelector('.amenGoogleScrollSpacer');
		const axis   = isPortrait ? 'scrollLeft' : 'scrollTop';
		const target = spacer ? (isPortrait ? spacer.offsetWidth : spacer.offsetHeight) : 0;
		this._scrollInstantly(el, axis, target);
	}

	_applyAdaDefaultScroll(resetRail = true) {
		const { isPortrait } = this.state;

		if (resetRail) {
			this._anchorPastSpacer(this.railRef.current, isPortrait);
		}
		this._anchorPastSpacer(this.listScrollRef.current, isPortrait);
	}

	/**
	 * The reach spacer is an ADA affordance: scrolling back over it pushes the top of the
	 * list down to hand height. Outside ADA mode it is dead space that a short result set
	 * cannot scroll away (see ai/kb/ui/leading-scroll-spacer-clamps-short-content.md), so
	 * it is not rendered at all.
	 */
	renderScrollSpacer() {
		// Landscape only. The spacer is sized by CSS that has no portrait rule — the
		// affordance is a *vertical* reach one — so rendering it in portrait would emit a
		// zero-size node that reads as working and does nothing.
		if (!this.isAdaActive() || this.state.isPortrait) { return null; }
		return <div className="amenGoogleScrollSpacer" aria-hidden="true" />;
	}

	detectOrientation() {
		if (!this.mapContainerRef.current) { return; }
		const { offsetWidth, offsetHeight } = this.mapContainerRef.current;
		this.setState({ isPortrait: offsetHeight > offsetWidth });
	}

	createMap() {
		const container = document.getElementById(this.containerId);
		if (!container || !window.google) { return; }

		const mapZoom = this.props.zoom || 14;

		const { Map } = window.google.maps;

		const mapOptions = {
			center:           { lat: this.latitude, lng: this.longitude },
			zoom:             mapZoom,
			minZoom:          Math.max(0, mapZoom - 3),
			maxZoom:          mapZoom + 3,
			disableDefaultUI: true,
			keyboardShortcuts: false,
			gestureHandling:  'greedy',
			clickableIcons:   false,
		};

		// Advanced Markers (the You-Are-Here pin and every category pin) need a real Map ID.
		// Precedence: the per-component google_map_id setting, then the per-env GOOGLE_MAP_ID
		// (condor/.aviary/env.json google.map_id). There is no third tier — Google's
		// DEMO_MAP_ID sentinel does not resolve for this project ("Unable to fetch
		// configuration for mapId DEMO_MAP_ID") and forcing it renders nothing at all, so a
		// missing Map ID costs the markers rather than the whole map.
		//
		// The setting is the authority — it ships a real default, so it normally wins and
		// GOOGLE_MAP_ID is only break-glass for a cleared field. That makes a stale env.json
		// invisible, so say so when the two disagree.
		const configuredMapId = this.props.google_map_id || googleMapIdENV;
		if (!configuredMapId) {
			console.warn('AmenitiesMap: No Map ID configured. Rendering a raster map without Advanced Markers — the You-Are-Here and place pins are skipped. Set the google_map_id setting or GOOGLE_MAP_ID.');
		} else if (this.props.google_map_id && googleMapIdENV && this.props.google_map_id !== googleMapIdENV) {
			console.warn(`AmenitiesMap: google_map_id setting (${this.props.google_map_id}) differs from GOOGLE_MAP_ID (${googleMapIdENV}); using the setting. Rotate both or clear GOOGLE_MAP_ID — see condor/docs/components/amenities_map.md.`);
		}
		if (configuredMapId) {
			mapOptions.mapId = configuredMapId;
		}

		this.googleMap = new Map(container, mapOptions);

		const { AdvancedMarkerElement } = window.google.maps.marker || {};
		this.advancedMarkersEnabled = Boolean(configuredMapId && AdvancedMarkerElement);

		if (this.advancedMarkersEnabled) {
			const yahImgEl = document.createElement('img');
			yahImgEl.src = 'https://ts-condor-assets.s3.amazonaws.com/images/icons/yah-icon.png';
			yahImgEl.className = 'amenGoogleYahPin';
			this.yahMarker = new AdvancedMarkerElement({
				position: { lat: this.latitude, lng: this.longitude },
				map:      this.googleMap,
				title:    'You Are Here',
				content:  yahImgEl,
				zIndex:   10,
			});
		}

		this.googleMap.addListener('click', () => {
			this.setState({ selectedPlace: null });
			if (this.infoWindow) { this.infoWindow.close(); }
			if (this.infoWindowRoot) { this.infoWindowRoot.unmount(); this.infoWindowRoot = null; }
			this.resetIdleTimer();
		});
		this.googleMap.addListener('drag', () => this.resetIdleTimer());
		this.googleMap.addListener('zoom_changed', () => this.resetIdleTimer());

		// The rail AND the listings panel are tappable before the Maps script resolves
		// — the "Loading map…" overlay is pointer-events: none — so on a slow player
		// (Windows) the user gets ahead of the map. Both paths then drop their work
		// with nothing to re-run it: placeMarkers() returns early on !this.googleMap,
		// and handlePlaceSelect() skips its whole InfoWindow branch for the same
		// reason while selectedPlace is never read in render(), so that tap gives no
		// feedback at all. Replay whatever the user already chose.
		const { category, results, selectedPlace, panelOpen } = this.state;
		if (category && results) {
			this.placeMarkers(results, category);
		}
		if (selectedPlace) {
			this.handlePlaceSelect(selectedPlace, selectedPlace.index); // pans itself
		} else {
			this.centerOnYouAreHere(panelOpen);
		}
	}

	resetIdleTimer() {
		const { navProps } = this.props;
		const configured = parseInt(navProps && navProps.idleTimeoutSeconds, 10);
		const idleTimeoutSeconds = configured > 0 ? configured : 60;
		clearTimeout(this.idleTimer);
		this.idleTimer = setTimeout(() => this.resetMap(), idleTimeoutSeconds * 1000);
	}

	resetMap() {
		this.clearMarkers();
		this.resultCache = {};
		this.cacheGeneration += 1;
		clearTimeout(this.categoryFetchTimer);
		clearTimeout(this.idleTimer);
		this.setState({
			category:      '',
			results:       null,
			fetchFailed:   false,
			loading:       false,
			selectedPlace: null,
			panelOpen:     false,
		}, () => this._applyAdaDefaultScroll());
		if (this.googleMap) {
			this.centerOnYouAreHere(false);
		}
	}

	/**
	 * panBy() args moving a centred point into the area the rail/panel don't cover.
	 * em multipliers mirror amenitiesGlobal.css — change them together.
	 *
	 * The rail and panel are measured in page pixels, but panBy() speaks the map's own
	 * CSS pixels, and on 4k those differ: amenitiesGlobal.css renders the map surface at
	 * HD dimensions and scales it with `zoom`, so one map pixel covers two page pixels.
	 * Dividing by mapCssScale() keeps the pan in step with the chrome it is dodging.
	 */
	visibleAreaPanOffset(panelOpen) {
		const container = this.mapContainerRef.current;
		if (!container) { return { dx: 0, dy: 0 }; }

		const fontSize = parseFloat(window.getComputedStyle(container).fontSize) || 16;
		const scale = mapCssScale();

		if (this.state.isPortrait) {
			let bottomOffset = 4.5 * fontSize;
			if (panelOpen) { bottomOffset += 5.5 * fontSize; }
			return { dx: 0, dy: bottomOffset / 2 / scale };
		}

		let rightOffset = 5.5 * fontSize;
		if (panelOpen) { rightOffset += 22.5 * fontSize; }
		return { dx: rightOffset / 2 / scale, dy: 0 };
	}

	centerOnYouAreHere(panelWillOpen = null) {
		if (!this.googleMap) return;
		this.googleMap.setZoom(this.props.zoom || 14);
		this.googleMap.panTo({ lat: this.latitude, lng: this.longitude });

		setTimeout(() => {
			if (!this.mapContainerRef.current || !this.googleMap) return;
			const panelOpen = panelWillOpen !== null ? panelWillOpen : this.state.panelOpen;
			const { dx, dy } = this.visibleAreaPanOffset(panelOpen);
			this.googleMap.panBy(dx, dy);
		}, 10);
	}

	centerInfoWindow(place) {
		if (!this.googleMap) { return; }
		this.googleMap.panTo({ lat: place.latitude, lng: place.longitude });

		setTimeout(() => {
			const container = this.mapContainerRef.current;
			if (!container || !this.googleMap) { return; }

			const popupEl = container.querySelector('.gm-style-iw-c');
			const popupHeight = (popupEl && popupEl.offsetHeight) || INFO_WINDOW_FALLBACK_HEIGHT_PX;

			const { dx, dy } = this.visibleAreaPanOffset(this.state.panelOpen);
			this.googleMap.panBy(dx, dy - (popupHeight / 2));
		}, 10);
	}

	/**
	 * Detaches the React root rendered into the InfoWindow and unmounts it on a
	 * later task.
	 *
	 * The deferral is load-bearing, not defensive. The InfoWindow's close button
	 * lives *inside* this root, so its onClick runs during the root's own React
	 * event dispatch. Unmounting synchronously from there makes React warn
	 * ("Attempted to synchronously unmount a root while React was already
	 * rendering") and can leave the teardown half-applied, which reads as the X
	 * not responding. Clearing the reference first keeps renderContent() from
	 * writing into a root that is about to go away.
	 */
	releaseInfoWindowRoot() {
		const root = this.infoWindowRoot;
		this.infoWindowRoot = null;
		if (root) {
			setTimeout(() => root.unmount(), 0);
		}
	}

	closeInfoWindow() {
		if (this.infoWindow) { this.infoWindow.close(); }
		this.releaseInfoWindowRoot();
	}

	clearMarkers() {
		this.closeInfoWindow();
		this.markers.forEach((m) => { m.map = null; });
		this.markers = [];
	}


	placeMarkers(results, categoryId) {
		this.clearMarkers();
		if (!this.googleMap || !results) { return; }

		const activeCategoryId = categoryId !== undefined ? categoryId : (this.state.category || '');

		if (!this.advancedMarkersEnabled) { return; }

		const { AdvancedMarkerElement } = window.google.maps.marker;

		results.forEach((result, index) => {
			const pinElement = createCategoryPinElement(activeCategoryId);

			const marker = new AdvancedMarkerElement({
				position: { lat: result.latitude, lng: result.longitude },
				map:      this.googleMap,
				title:    result.name,
				content:  pinElement,
			});

			marker.addListener('click', () => {
				this.handlePlaceSelect(result, index);
				this.resetIdleTimer();
			});

			this.markers.push(marker);
		});
	}

	handleCategorySelect(categoryId) {
		if (this.props.showPhase === false) { return; }

		const { category, fetchFailed } = this.state;

		clearTimeout(this.categoryFetchTimer);

		if (category === categoryId && !fetchFailed) {
			this.setState({ category: '', results: null, fetchFailed: false, loading: false, panelOpen: false, selectedPlace: null });
			this.clearMarkers();
			if (this.googleMap) {
				this.centerOnYouAreHere(false);
			}
			return;
		}

		this.setState({ category: categoryId, loading: true, results: null, fetchFailed: false, selectedPlace: null, panelOpen: true }, () => {
			this._applyAdaDefaultScroll(false);
		});
		this.resetIdleTimer();

		const delay = this.resultCache[categoryId] ? 0 : CATEGORY_FETCH_DEBOUNCE_MS;
		this.categoryFetchTimer = setTimeout(() => this.loadCategoryResults(categoryId), delay);
	}

	async loadCategoryResults(categoryId) {
		const places_search_radius = this.props.places_search_radius || 3000;
		const generation = this.cacheGeneration;
		let results = this.resultCache[categoryId];

		if (!results) {
			const inFlightKey = `${generation}|${categoryId}`;
			if (this.inFlightCategories.has(inFlightKey)) { return; }

			this.inFlightCategories.add(inFlightKey);
			try {
				results = await fetchGoogleNearbyPlaces(
					categoryId,
					places_search_radius,
					this.latitude,
					this.longitude,
				);
			} finally {
				this.inFlightCategories.delete(inFlightKey);
			}
			if (results && generation === this.cacheGeneration) {
				this.resultCache[categoryId] = results;
			}
		}

		if (!this._mounted || generation !== this.cacheGeneration || this.state.category !== categoryId) { return; }

		if (!results) {
			this.clearMarkers();
			this.setState({ results: null, fetchFailed: true, loading: false }, () => this._applyAdaDefaultScroll(false));
			return;
		}

		this.setState({ results, fetchFailed: false, loading: false }, () => this._applyAdaDefaultScroll(false));
		this.placeMarkers(results, categoryId);

		if (this.googleMap && results.length > 0) {
			this.centerOnYouAreHere(true);
		}
	}

	handlePlaceSelect(place, index) {
		if (this.props.showPhase === false) { return; }

		this.setState({ selectedPlace: { ...place, index } });
		if (this.googleMap) {
			if (!this.infoWindow) {
				this.infoWindow = new window.google.maps.InfoWindow({ maxWidth: 290, disableAutoPan: true });
				this.infoWindow.addListener('closeclick', () => {
					this.releaseInfoWindowRoot();
					this.setState({ selectedPlace: null });
				});
			}

			const mapsLink = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
				`${place.name}, ${place.formatted_address}`
			)}`;

			const catMeta = CATEGORIES.find((c) => c.id === this.state.category);

			const renderContent = (hoursText, fullAddress, phone) => {
				const onClose = () => {
					this.closeInfoWindow();
					this.setState({ selectedPlace: null });
				};
				if (!this.infoWindowRoot) { return; }
				this.infoWindowRoot.render(
					<MapInfoWindowContent
						place={place}
						mapsLink={mapsLink}
						onClose={onClose}
						hoursText={hoursText}
						fullAddress={fullAddress}
						phone={phone}
						catMeta={catMeta}
					/>
				);
			};

			// Google Maps' InfoWindow.setContent() requires a raw DOM node, not JSX.
			// We create a dedicated React root on that DOM node so we can render
			// React components (MapInfoWindowContent) into it imperatively, and
			// update it later (e.g. once place-detail data arrives) via root.render().
			// Selecting a new place replaces the previous root. handlePlaceSelect is
			// reached from a React onClick (listings row) as well as a Google marker
			// listener, so the old root is released rather than unmounted inline.
			const container = document.createElement('div');
			this.releaseInfoWindowRoot();
			this.infoWindowRoot = createRoot(container);
			renderContent(null, null, null);

			this.infoWindow.setContent(container);
			const anchor = this.markers[index];
			if (anchor) {
				this.infoWindow.open({ anchor, map: this.googleMap });
			} else {
				this.infoWindow.setPosition({ lat: place.latitude, lng: place.longitude });
				this.infoWindow.open({ map: this.googleMap });
			}
			this.centerInfoWindow(place);

			if (place.place_id) {
				fetchGooglePlaceDetails(place.place_id).then((details) => {
					if (!details || !this.infoWindowRoot) { return; }
					const openNow   = details.open_now;
					const hoursText = getHoursText(openNow, details.periods || [], details.weekday_text || []);
					const fullAddress = details.formatted_address || null;
					const phone = details.phone || null;
					renderContent(hoursText, fullAddress, phone);
				});
			}
		}
		this.resetIdleTimer();
	}

	closeDetailCard() {
		this.setState({ selectedPlace: null });
		this.closeInfoWindow();
	}

	handleZoomIn() {
		if (this.googleMap) {
			this.googleMap.setZoom(this.googleMap.getZoom() + 1);
			this.resetIdleTimer();
		}
	}

	handleZoomOut() {
		if (this.googleMap) {
			this.googleMap.setZoom(this.googleMap.getZoom() - 1);
			this.resetIdleTimer();
		}
	}

	handleRecenter() {
		this.resetMap();
	}

	handleMapPan(dx, dy) {
		if (!this.googleMap) { return; }
		const PAN_AMOUNT = 80;
		this.googleMap.panBy(dx * PAN_AMOUNT, dy * PAN_AMOUNT);
		this.resetIdleTimer();
	}

	scrollRail(dir) {
		const el = this.railRef.current;
		if (!el) { return; }
		const btn  = el.querySelector('.amenGoogleCatBtn');
		const hAmt = Math.max(btn ? btn.offsetWidth  * 2.5 : 0, 200);
		const vAmt = Math.max(btn ? btn.offsetHeight * 2   : 0, 130);
		if (dir === 'up')    { el.scrollBy({ top: -vAmt, behavior: 'smooth' }); }
		if (dir === 'down')  { el.scrollBy({ top:  vAmt, behavior: 'smooth' }); }
		if (dir === 'left')  { el.scrollBy({ left: -hAmt, behavior: 'smooth' }); }
		if (dir === 'right') { el.scrollBy({ left:  hAmt, behavior: 'smooth' }); }
	}

	scrollList(dir) {
		const el = this.listScrollRef.current;
		if (!el) { return; }
		const row  = el.querySelector('.amenGoogleListRow');
		const hAmt = Math.max(row ? row.offsetWidth  : 0, 350);
		const vAmt = Math.max(row ? row.offsetHeight : 0, 60);
		if (dir === 'up')    { el.scrollBy({ top: -vAmt, behavior: 'smooth' }); }
		if (dir === 'down')  { el.scrollBy({ top:  vAmt, behavior: 'smooth' }); }
		if (dir === 'left')  { el.scrollBy({ left: -hAmt, behavior: 'smooth' }); }
		if (dir === 'right') { el.scrollBy({ left:  hAmt, behavior: 'smooth' }); }
	}

	_onDragStart(e, ref, axis, key) {
		const el = ref.current;
		if (!el) { return; }
		this[key] = {
			startX:     e.clientX,
			startY:     e.clientY,
			scrollLeft: el.scrollLeft,
			scrollTop:  el.scrollTop,
		};
		el.style.cursor = 'grabbing';
	}

	_onDragMove(e, ref, axis, key) {
		const drag = this[key];
		if (!drag) { return; }
		const el = ref.current;
		if (!el) { return; }
		const dx = e.clientX - drag.startX;
		const dy = e.clientY - drag.startY;
		if (axis === 'x') { this._scrollInstantly(el, 'scrollLeft', drag.scrollLeft - dx); }
		if (axis === 'y') { this._scrollInstantly(el, 'scrollTop',  drag.scrollTop  - dy); }
	}

	_onDragEnd(ref, key) {
		const el = ref.current;
		if (el) { el.style.cursor = 'grab'; }
		this[key] = null;
	}


	renderMapControls() {
		const gpsIcon = (
			<svg viewBox="0 0 24 24" fill="currentColor" width="1.1em" height="1.1em" aria-hidden="true">
				<path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
			</svg>
		);
		return (
			<div className="amenGoogleMapControls">
				<div className="amenGoogleZoomGroup">
					<button className="amenGoogleCtrlBtn" onClick={() => this.handleRecenter()} aria-label="Current location">{gpsIcon}</button>
					<div className="amenGoogleZoomStack">
						<button className="amenGoogleZoomBtn" onClick={() => this.handleZoomIn()}  aria-label="Zoom in"><FontAwesomeIcon icon={faPlus} aria-hidden="true" /></button>
						<button className="amenGoogleZoomBtn" onClick={() => this.handleZoomOut()} aria-label="Zoom out"><FontAwesomeIcon icon={faMinus} aria-hidden="true" /></button>
					</div>
				</div>
				<div className="amenGooglePanDpad" aria-label="Pan map">
					<div className="amenGooglePanGrid">
						<span/>
						<button className="amenGoogleCtrlBtn amenGooglePanBtn" onClick={(e) => { this.handleMapPan(0, -1); e.currentTarget.blur(); }} aria-label="Pan up">
							<svg viewBox="0 0 24 24" fill="currentColor" width="100%" height="100%"><polygon points="12,6 6,17 18,17"/></svg>
						</button>
						<span/>
						<button className="amenGoogleCtrlBtn amenGooglePanBtn" onClick={(e) => { this.handleMapPan(-1, 0); e.currentTarget.blur(); }} aria-label="Pan left">
							<svg viewBox="0 0 24 24" fill="currentColor" width="100%" height="100%"><polygon points="6,12 17,6 17,18"/></svg>
						</button>
						<span/>
						<button className="amenGoogleCtrlBtn amenGooglePanBtn" onClick={(e) => { this.handleMapPan(1,  0); e.currentTarget.blur(); }} aria-label="Pan right">
							<svg viewBox="0 0 24 24" fill="currentColor" width="100%" height="100%"><polygon points="18,12 7,6 7,18"/></svg>
						</button>
						<span/>
						<button className="amenGoogleCtrlBtn amenGooglePanBtn" onClick={(e) => { this.handleMapPan(0,  1); e.currentTarget.blur(); }} aria-label="Pan down">
							<svg viewBox="0 0 24 24" fill="currentColor" width="100%" height="100%"><polygon points="12,18 6,7 18,7"/></svg>
						</button>
						<span/>
					</div>
				</div>
			</div>
		);
	}

	renderCategoryRail(filteredCategories, isPortrait) {
		const { category } = this.state;
		const buttons = filteredCategories.map((cat) => (
			<button
				key={cat.id}
				className={`amenGoogleCatBtn${category === cat.id ? ' amenGoogleCatBtnActive' : ''}`}
				data-test-id="amenitiesCatBtn"
				onClick={() => this.handleCategorySelect(cat.id)}
				aria-pressed={category === cat.id}
				aria-label={cat.label}
			>
				{cat.fa ? (
					<FontAwesomeIcon icon={cat.fa} className="amenGoogleCatIcon" data-test-id="amenitiesCatIcon" aria-hidden="true" />
				) : (
					<img
						className="amenGoogleCatIcon"
						data-test-id="amenitiesCatIcon"
						src={cat.icon}
						alt=""
						aria-hidden="true"
						onError={(e) => { e.target.style.display = 'none'; }}
					/>
				)}
				<span className="amenGoogleCatLabel">{cat.label}</span>
			</button>
		));

		if (isPortrait) {
			return (
				<>
					<button className="amenGoogleScrollBtn amenGoogleScrollBtnLeft"  onClick={() => this.scrollRail('left')}  aria-label="Scroll categories left"><FontAwesomeIcon icon={faChevronLeft} aria-hidden="true" /></button>
					<div
						className="amenGoogleRailScroll"
						ref={this.railRef}
						style={{ cursor: 'grab' }}
						onPointerDown={(e) => this._onDragStart(e, this.railRef, 'x', '_railDrag')}
						onPointerMove={(e) => this._onDragMove(e, this.railRef, 'x', '_railDrag')}
						onPointerUp={() => this._onDragEnd(this.railRef, '_railDrag')}
						onPointerLeave={() => this._onDragEnd(this.railRef, '_railDrag')}
						onPointerCancel={() => this._onDragEnd(this.railRef, '_railDrag')}
					>{buttons}</div>
					<button className="amenGoogleScrollBtn amenGoogleScrollBtnRight" onClick={() => this.scrollRail('right')} aria-label="Scroll categories right"><FontAwesomeIcon icon={faChevronRight} aria-hidden="true" /></button>
				</>
			);
		}
		return (
			<>
				<div
					className="amenGoogleRailScroll"
					ref={this.railRef}
					style={{ cursor: 'grab' }}
					onPointerDown={(e) => this._onDragStart(e, this.railRef, 'y', '_railDrag')}
					onPointerMove={(e) => this._onDragMove(e, this.railRef, 'y', '_railDrag')}
					onPointerUp={() => this._onDragEnd(this.railRef, '_railDrag')}
					onPointerLeave={() => this._onDragEnd(this.railRef, '_railDrag')}
					onPointerCancel={() => this._onDragEnd(this.railRef, '_railDrag')}
				>{this.renderScrollSpacer()}<div className="amenGoogleRailFill">{buttons}</div></div>
				<div className="amenGoogleRailBottomControls">
				<button className="amenGoogleScrollBtn amenGoogleRailScrollBtn"   onClick={() => this.scrollRail('up')}   aria-label="Scroll categories up"><FontAwesomeIcon icon={faChevronUp} aria-hidden="true" /></button>
				<button className="amenGoogleScrollBtn amenGoogleRailScrollBtn" onClick={() => this.scrollRail('down')} aria-label="Scroll categories down"><FontAwesomeIcon icon={faChevronDown} aria-hidden="true" /></button></div>
			</>
		);
	}

	renderListingsPanel() {
		const { category, results, loading, fetchFailed, isPortrait } = this.state;
		const catMeta = CATEGORIES.find((c) => c.id === category);

		const listContent = (
			<>
				{loading && (
					<div className="amenGoogleListMsg">Loading&hellip;</div>
				)}
				{!loading && fetchFailed && (
					<div className="amenGoogleListMsg">Couldn&rsquo;t load nearby places. Tap the category again to retry.</div>
				)}
				{!loading && !fetchFailed && results && results.length === 0 && (
					<div className="amenGoogleListMsg">No results found nearby</div>
				)}
				{!loading && !fetchFailed && !results && (
					<div className="amenGoogleListMsg">Select a category</div>
				)}
				{!loading && results && results.length > 0 && results.map((place, index) => {
					const displayType = getDisplayType(place.types);
					const priceEl    = renderPriceLevel(place.price_level);
					const openStatus = getOpenStatus(place);
					return (
						<button
							key={place.place_id || index}
							className="amenGoogleListRow"
							onClick={() => {
								this.handlePlaceSelect(place, index);
								this.resetIdleTimer();
							}}
						>
							<span className="amenGoogleListNum">{index + 1}</span>
							<span className="amenGoogleListThumb">
								<PlaceThumb place={place} catMeta={catMeta} />
							</span>
							<span className="amenGoogleListInfo">
								<span className="amenGoogleListName">{place.name}</span>
								{place.rating > 0 && (
									<span className="amenGoogleListRating">
										{renderStars(place.rating)}
										<span className="amenGoogleRatingNum">
											{place.rating.toFixed(1)}
											{place.user_ratings_total > 0 && (
												<span className="amenGoogleRatingCount"> ({place.user_ratings_total} reviews)</span>
											)}
										</span>
									</span>
								)}
								<span className="amenGoogleListMeta">
									{displayType && <span className="amenGoogleListType">{displayType}</span>}
									{priceEl}
									{openStatus && (
										<span className="amenGoogleListStatus">{openStatus.label}</span>
									)}
								</span>
							</span>
						</button>
					);
				})}
			</>
		);

		return (
			<>
				<div className="amenGooglePanelHeader">
					<span className="amenGooglePanelHeaderLabel">{catMeta ? catMeta.label : ''}</span>
					{isPortrait && (
						<button className="amenGoogleScrollBtn amenGooglePortraitCloseBtn" onClick={() => this.resetMap()} aria-label="Close">
							<FontAwesomeIcon icon={faAngleDoubleDown} aria-hidden="true" />
						</button>
					)}
				</div>

				<div className="amenGooglePanel" ref={this.listPanelRef}>
					{isPortrait ? (
						<div className="amenGoogleListScrollWrap">
							<button className="amenGoogleScrollBtn amenGoogleScrollBtnLeft"  onClick={() => this.scrollList('left')}  aria-label="Scroll left"><FontAwesomeIcon icon={faChevronLeft} aria-hidden="true" /></button>
							<div
								className="amenGoogleListScroll"
								ref={this.listScrollRef}
								style={{ cursor: 'grab' }}
								onPointerDown={(e) => this._onDragStart(e, this.listScrollRef, 'x', '_listDrag')}
								onPointerMove={(e) => this._onDragMove(e, this.listScrollRef, 'x', '_listDrag')}
								onPointerUp={() => this._onDragEnd(this.listScrollRef, '_listDrag')}
								onPointerLeave={() => this._onDragEnd(this.listScrollRef, '_listDrag')}
								onPointerCancel={() => this._onDragEnd(this.listScrollRef, '_listDrag')}
							>{this.renderScrollSpacer()}<div className="amenGoogleListFill">{listContent}</div></div>
							<button className="amenGoogleScrollBtn amenGoogleScrollBtnRight" onClick={() => this.scrollList('right')} aria-label="Scroll right"><FontAwesomeIcon icon={faChevronRight} aria-hidden="true" /></button>
						</div>
					) : (
						<>
							<div className="amenGoogleListScrollWrap">
								<div className="amenGoogleLandscapeScrollControls">
									<button className="amenGoogleScrollBtn amenGoogleScrollBtnBottom" style={{height: '100%'}} onClick={() => this.resetMap()} aria-label="Close">
										<FontAwesomeIcon icon={faAngleDoubleRight} aria-hidden="true" />
									</button>
								</div>
								<div
									className="amenGoogleListScroll"
									ref={this.listScrollRef}
									style={{ cursor: 'grab' }}
									onPointerDown={(e) => this._onDragStart(e, this.listScrollRef, 'y', '_listDrag')}
									onPointerMove={(e) => this._onDragMove(e, this.listScrollRef, 'y', '_listDrag')}
									onPointerUp={() => this._onDragEnd(this.listScrollRef, '_listDrag')}
									onPointerLeave={() => this._onDragEnd(this.listScrollRef, '_listDrag')}
									onPointerCancel={() => this._onDragEnd(this.listScrollRef, '_listDrag')}
								>{this.renderScrollSpacer()}<div className="amenGoogleListFill">{listContent}</div></div>
							</div>
							<div className="amenGooglePanelFooter">
								<button className="amenGoogleScrollBtn amenGoogleFooterScrollBtn" onClick={() => this.scrollList('up')} aria-label="Scroll up"><FontAwesomeIcon icon={faChevronUp} aria-hidden="true" /></button>
								<button className="amenGoogleScrollBtn amenGoogleFooterScrollBtn" onClick={() => this.scrollList('down')} aria-label="Scroll down"><FontAwesomeIcon icon={faChevronDown} aria-hidden="true" /></button>
							</div>
						</>
					)}
				</div>
			</>
		);
	}

	render() {
		const {
			custom_classes,
			modifier_classes,
			amenity_categories,
			hide_map_buttons,
			keyNum,
		} = this.props;

		const {
			css,
			panelOpen,
			isPortrait,
			mapsReady,
		} = this.state;

		let customClasses = '';
		if (custom_classes && custom_classes.length > 0) {
			custom_classes.forEach((cls) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(cls)) {
					customClasses += ` ${cls}`;
				}
			});
		}
		let modifierClasses = '';
		if (modifier_classes && modifier_classes.length > 0) {
			modifier_classes.forEach((cls) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(cls)) {
					modifierClasses += ` ${cls}`;
				}
			});
		}

		const enabledIds = new Set(
			(amenity_categories || '').split(',').map((s) => s.trim()).filter(Boolean)
		);
		const filteredCategories = enabledIds.size > 0
			? CATEGORIES.filter((c) => enabledIds.has(c.id))
			: CATEGORIES;

		const orientationClass = isPortrait ? 'amenGooglePortrait' : 'amenGoogleLandscape';

		return (
			<div
				className={`${css.amenitiesMapContainer} ${modifierClasses} ${customClasses} ${orientationClass}${panelOpen ? ' amenGooglePanelOpen' : ''}`}
				ref={this.mapContainerRef}
				style={{ width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }}
				key={`amenGoogleMap${keyNum}`}
			>
				<div
					id={this.containerId}
					className="amenGoogleMapCanvas"
					style={{ width: '100%', height: '100%' }}
				/>

				{!mapsReady && (
					<div className="amenGoogleMapLoading">Loading map&hellip;</div>
				)}

				<div className={`amenGooglePanelWrap${panelOpen ? ' amenGooglePanelWrapOpen' : ''}`}>
					{this.renderListingsPanel()}
				</div>

				<div className={`amenGoogleRail ${isPortrait ? 'amenGoogleRailBottom' : 'amenGoogleRailRight'}`}>
					{this.renderCategoryRail(filteredCategories, isPortrait)}
				</div>

				{mapsReady && !hide_map_buttons && this.renderMapControls()}
			</div>
		);
	}
}

export default AmenitiesResponsiveMap;
